'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { Currency, CurrencyCode, currencies } from '@/lib/currency';
import useHosting from './useHosting';
interface CurrencyContextValue {
  currency: CurrencyCode;
  setCurrency: (_code: CurrencyCode) => void;
  selectedCurrencyObject: Currency | undefined;
  currencies: Currency[];
}

const CurrencyContext = createContext<CurrencyContextValue | undefined>(undefined);

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const [currency, setCurrency] = useState<CurrencyCode>(() => {
    if (typeof window !== 'undefined') {
      return (localStorage.getItem('preferredCurrency') as CurrencyCode) || 'EGP';
    }
    return 'EGP';
  });

  const { isHosting } = useHosting();

  useEffect(() => {
    const stored = localStorage.getItem('preferredCurrency');
    if (stored) setCurrency(stored as CurrencyCode);
  }, []);

  useEffect(() => {
    localStorage.setItem('preferredCurrency', currency);
  }, [currency]);

  useEffect(() => {
    if (isHosting) setCurrency('EGP');
  }, [isHosting]);

  const selectedCurrencyObject = currencies.find((c) => c.code === currency);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, selectedCurrencyObject, currencies }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export default function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used within <CurrencyProvider>');
  return ctx;
}
